import React, { FC } from 'react';
import { buildCollectionTiles } from '../ItvRowCollection/utils/collectionTiles';
import { RowCollectionLayout } from '../ItvRowCollection/layouts/types';
import { PlatformPromos } from '../../../hooks/useFetchPlatformPromos/types';
import { GetItvCollectionBySlugQuery } from '../../../libs/graphql/betzoneDirectusAPI/queries/__generated__/getItvCollectionBySlug.query.generated';
import { HandleClaimClick } from '../../../layouts/pages/ItvGenericPage';
import { ItvViewAllGrid } from './ItvViewAllGrid';
import { ItvCollectionType } from '../types';
import './ItvViewAll.scss';

type ViewAllCollectionData = GetItvCollectionBySlugQuery['collection'][0];

interface ItvViewAllProps {
  collection: ViewAllCollectionData;
  onBack: () => void;
  platformPromos?: PlatformPromos;
  handleClaimClick?: HandleClaimClick;
}

export const ItvViewAll: FC<ItvViewAllProps> = ({ collection, onBack, platformPromos, handleClaimClick }) => {
  const title = collection.translations?.[0]?.title || 'View All';
  const isOneRowMobile = collection.type === ItvCollectionType.PROMOTIONS;

  const tiles = buildCollectionTiles({
    collectionId: collection.id,
    collectionType: collection.type,
    layoutType: 'grid-5x5' as RowCollectionLayout, // 5 items per row grid layout
    games: collection.games,
    promotions: collection.promotions,
    fallbackImages: [],
    stubImageClassName: 'itv-view-all__item',
    platformPromos,
    handleClaimClick,
  });

  return <ItvViewAllGrid title={title} tiles={tiles} isOneRowMobile={isOneRowMobile} onBack={onBack} />;
};
